import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/component/contact/ContactArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layouts/footers/FooterOne.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layouts/headers/HeaderOne.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/layouts/Wrapper.tsx");
